import { render, staticRenderFns } from "./InderfaceDetails.vue?vue&type=template&id=653a8f12&scoped=true"
import script from "./InderfaceDetails.vue?vue&type=script&lang=js"
export * from "./InderfaceDetails.vue?vue&type=script&lang=js"
import style0 from "./InderfaceDetails.vue?vue&type=style&index=0&id=653a8f12&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a8f12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653a8f12')) {
      api.createRecord('653a8f12', component.options)
    } else {
      api.reload('653a8f12', component.options)
    }
    module.hot.accept("./InderfaceDetails.vue?vue&type=template&id=653a8f12&scoped=true", function () {
      api.rerender('653a8f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/Interface/InderfaceDetails.vue"
export default component.exports